import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-report-supplemental',
  templateUrl: './report-supplemental.component.html',
  styleUrls: ['./report-supplemental.component.scss']
})
export class ReportSupplementalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
